import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import NavBar from './NavBar';
import Countdown from './Countdown';
import DraftPicks from './DraftPicks';
import Rules from './Rules';
import Leadership from './Leadership';
import PastChampions from './PastChampions';

const AppShell = () => {
  const location = useLocation();
  const isDraftRoute =
    location.pathname === '/' || location.pathname.startsWith('/draft-board');

  return (
    <div className="App">
      {/* Modern navigation with integrated branding */}
      <NavBar />

      {/* Countdown only on Draft pages; docks to top on scroll */}
      {isDraftRoute && (
        <div className="countdown-dock">
          <Countdown />
        </div>
      )}

      <Routes>
        <Route path="/" element={<DraftPicks />} />
        <Route path="/draft-board/*" element={<DraftPicks />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/past-champions" element={<PastChampions />} />
      </Routes>
    </div>
  );
};

const App = () => (
  <Router>
    <AppShell />
  </Router>
);

export default App;
